import { Certificate } from "./Certificate";
import Heading from "../Heading";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect, useState } from "react";

export const CertificatePart = () => {
  const [slidesToShow, setSlidesToShow] = useState(3);

  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRepos = async () => {
      try {
        const response = await fetch(
          "https://raw.githubusercontent.com/anmolkumarshah/data-for-portfolio/main/data.json"
        );
        if (!response.ok) {
          throw new Error(`Error: ${response.status} ${response.statusText}`);
        }
        const data = await response.json();

        setCertificates(data["certificates"]);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchRepos();
  }, []);



  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1000) {
        setSlidesToShow(1);
      } else {
        setSlidesToShow(3);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Set initial value based on current window size

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  var settings = {
    dots: false,
    lazyLoad: 'ondemand',
    infinite: true,
    autoplay: true,
    speed: 200,
    slidesToShow: slidesToShow,
    slidesToScroll: 2,
    adaptiveHeight: true,
    mobileFirst: true,
  };

  if (loading) return <div className="text-center mt-10">Loading...</div>;
  if (error)
    return <div className="text-center mt-10 text-red-500">Error: {error}</div>;

  return (
    <div id="certification" className="mx-3 md:mx-20 h-96">
      <Heading text={"Certifications"} />
      <Slider {...settings} arrows={false}>
        {certificates.map((e) => (
          <Certificate key={e.img} img={e.img} title={e.title} />
        ))}
      </Slider>
    </div>
  );
};
